import Rx from 'rx';
import {isValidDate} from "../app";

export default function BidsOffersService($wamp, progressBar, UserService) {

  let bidsOffersCache = new Rx.ReplaySubject(1), meta = {}, report;
  function load(r) {

    report = r || 'current';

    let rpc = () =>  {
      progressBar.add('bids-offers');
      return $wamp.call('org.eggs.get_bo', [report]);
    };

    if (isValidDate(report)) {
      rpc = () => {
        progressBar.add('bids-offers');
        return $wamp.call('org.eggs.get_bo_history', [report]);
      };
    }

    return Rx.Observable
        .defer(rpc)
        .repeatWhen(function (attempts) {
          return attempts.concatMap(UserService.subject.take(1)).filter(function (user) {
            return user.roles.indexOf('refresh') > 0;
          }).delay(300000);
        })
        .do(function (res) {
              meta.reportDate = res.args[1];
              meta.lastUpdated = new Date();
              progressBar.remove('bids-offers');
            },
            function (err) {
              console.error(err);
              progressBar.remove('bids-offers');
            })
        .map(function (res) {
          return res.args[0] || [];
        })
        .doOnNext(function (value) {
          bidsOffersCache.onNext(value);
        });
  }

  // A row is part of a combo when Combo is set and non-zero; the value is the parent combo id,
  // shared by every part of the combo.
  function isCombo(bo) {
    return !!bo && bo.Combo != null && Number(bo.Combo) !== 0;
  }

  // All cached rows that share the combo of BoID (BoID itself included), or [] when it's not a combo.
  function comboParts(BoID) {
    return bidsOffersCache
        .map(function (rows) {
          var me = (rows || []).filter(function (r) {
            return r.BoID === BoID;
          })[0];
          if (!isCombo(me)) {
            return [];
          }
          return rows.filter(function (r) {
            return isCombo(r) && String(r.Combo) === String(me.Combo);
          });
        })
        .debounce(100);
  }

  return {
    cache: bidsOffersCache,
    isCombo: isCombo,
    comboParts: comboParts,
    get: function (BoID) {
      return bidsOffersCache
          .flatMap(function (s) {
            return Rx.Observable.from(s);
          })
          .filter(function (bo) {
            return BoID === bo.BoID;
          })
          .debounce(100); //Performance loop
    },
    load: load,
    meta: function () {
      return meta;
    },
    clearCache: function () {
      bidsOffersCache.onNext([]);
    },
    currentReport: function () {
      return report;
    },
    // Tells the backend a member applied, changed or cleared the board's Filters, so it lands in
    // the RPC log. Best effort: nothing is shown and a failure is ignored.
    logFilters: function (selection, resultCount, source) {
      return $wamp.call('org.eggs.filter_applied', ['bids_offers', selection, resultCount, source])
          .catch(function () {});
    }
  };
}
